export default "__VITE_ASSET__DXxtIH2N__"